import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { Chip, DialogActions, Grid, TextField } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import { createTag } from 'lib/api/tags';
import { useDispatch } from 'react-redux';
import { showAlert, getBestTextColorFromHex } from 'lib/functions/utils';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';

const AddTag = (props: any) => {
  const { open, onClose, category, setUp } = props;
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [color, setColor] = useState('#000000');
  const dispatch = useDispatch();

  const handleCreateTag = async () => {
    if (!name || !description || !color) {
      showAlert(dispatch, 'error', 'Todos los campos son requeridos');
      return;
    };
    setLoading(true);
    try {
      await createTag(dispatch, {
        name,
        description,
        color: color.toUpperCase(),
        tagCategoryId: category.id
      });
      showAlert(dispatch, 'success', 'Tag creado correctamente');
      setUp(category.id);
      onClose();
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al crear el tag');
    }
    setLoading(false);
  };

  const handleChangeColor = (e: any) => {
    const regex = /^#([0-9a-fA-F]{6})$/;
    if (!regex.test(e.target.value)) {
      return;
    }
    setColor(e.target.value);
  };

  return (
    <div>
      <Dialog open={open} maxWidth="sm" >
        <DialogTitle>Crear Tag</DialogTitle>
        <DialogContent>
          {loading && (
            <div style={{ minHeight: 100 }}>
              <CenteredCircularProgress type="dialog" />
            </div>
          )}
          {!loading && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={8} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography fontWeight={600}>Nombre:</Typography>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                  <TextField
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Nombre"
                    style={{ width: '100%' }}
                  />
                </Grid>
                <Grid item xs={8} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography fontWeight={600}>Descripción:</Typography>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                  <TextField
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Descripción"
                    multiline
                    style={{ width: '100%' }}
                  />
                </Grid>
                <Grid item xs={8} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography fontWeight={600}>Color:</Typography>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
                    <input
                      type="color"
                      value={color}
                      onChange={(e) => handleChangeColor(e)}
                      style={{
                        width: 40,
                        height: 40,
                        border: 'none',
                        borderRadius: 4,
                        cursor: 'pointer'
                      }}
                    />
                    <TextField
                      value={color}
                      onChange={(e) => handleChangeColor(e)}
                      placeholder="#000000"
                      size="small"
                      style={{ flex: 1 }}
                    />
                  </div>
                </Grid>
              </Grid>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Chip
                  label={name}
                  sx={{ backgroundColor: color, color: getBestTextColorFromHex(color), fontWeight: 600 }}
                  style={{ width: 'fit-content' }}
                />
              </div>
            </div>
          )
          }
        </DialogContent >
        <DialogActions>
          <CustomButton
            onClick={onClose}
            color="secondary"
            disabled={loading}
          >
            Salir
          </CustomButton>
          <CustomButton
            onClick={handleCreateTag}
            color="success"
            disabled={loading}
          >
            Guardar
          </CustomButton>
        </DialogActions>
      </Dialog >
    </div >
  );
};

export default AddTag;